export interface CandidateEmailEngagementEvent {
  eventType: string;
  timestamp: string;
  reason?: string | null;
}

export interface CandidateEmailEngagementEmail {
  sequenceId?: string;
  itemId?: string;
  messageType?: string;
  subject?: string | null;
  isOpened?: boolean;
  lastEventStatus?: string;
  lastEventTimestamp?: string | null;
  sentAt?: string | null;
  events?: CandidateEmailEngagementEvent[];
}

export interface CandidateEmailEngagementHistory {
  hasEngagement: boolean;
  candidateId?: string;
  vacancyId?: string;
  isOpened?: boolean;
  lastEventStatus?: string;
  lastEventTimestamp?: string;
  sentAt?: string;
  events?: CandidateEmailEngagementEvent[];
  emails?: CandidateEmailEngagementEmail[];
}

export function getEmailEngagementStatusClass(status?: string | null): string {
  const value = (status || '').toLowerCase();
  if (value === 'opened' || value === 'clicked') {
    return 'is-opened';
  }
  if (value === 'delivered') {
    return 'is-delivered';
  }
  return 'is-sent';
}

export function getEmailEngagementStatusIconClass(status?: string | null): string {
  const value = (status || '').toLowerCase();
  switch (value) {
    case 'delivered':
      return 'app-ico-mask__email-delivered';
    case 'clicked':
      return 'app-ico-mask__email-clicked';
    case 'opened':
      return 'app-ico-mask__envelope';
    case 'sent':
    default:
      return 'app-ico-mask__send-plane';
  }
}

export function getEmailEngagementStatusKey(status?: string | null): string {
  switch ((status || 'Sent').toLowerCase()) {
    case 'delivered':
      return 'VacanciesMatch.EmailEngagementHistory.StatusDelivered';
    case 'opened':
      return 'VacanciesMatch.EmailEngagementHistory.StatusOpened';
    case 'clicked':
      return 'VacanciesMatch.EmailEngagementHistory.StatusClicked';
    default:
      return 'VacanciesMatch.EmailEngagementHistory.StatusSent';
  }
}
